/* @flow */
import * as React from 'react';
import DeviceActions from 'actions/DeviceActions';
import UserActions from 'user/UserActions';
import CurrentUser from 'auth/CurrentUser';
import ToastActions from 'actions/ToastActions';
import Link from 'components/Link.jsx';

/* Component to resend a confirmation email:
 *
 * if (user.getUnconfirmedEmail()) {
 *  var resent = <ResendConfirmationEmail>Click me!</ResendConfirmationEmail>;
 * }
 *
 */

type Props = {
  /* silences all the toasts, default false */
  silent: boolean,
  /* called if API returned 2xx */
  onSuccess?: Function,
  /* called if API did not return 2xx */
  onError?: Function,
  email: {
    endpoint: string,
    id: number,
    type: 'email',
  },
  children: React$Node,
};
class ResendConfirmationEmail extends React.Component<Props> {
  static defaultProps = {
    silent: false,
  };

  resendConfirmation = () => {
    const { email, silent, onError, onSuccess } = this.props;
    const success = () => {
      const emailAddress = (email && email.endpoint) || CurrentUser.getUser().getUnconfirmedEmail();

      if (!silent) {
        ToastActions.showSuccessToast(`Sent confirmation link to ${emailAddress}`);
      }
      if (onSuccess) {
        onSuccess();
      }
    };

    const onFailure = () => {
      if (!silent) {
        ToastActions.showDefaultErrorToast();
      }
      if (onError) {
        onError();
      }
    };

    if (email) {
      DeviceActions.resendConfirmationEmail(email.endpoint).then(success, onFailure);
    } else {
      UserActions.requestConfirmation().then(success, onFailure);
    }
  };

  render() {
    return (
      <Link onClick={this.resendConfirmation} {...this.props}>
        {this.props.children}
      </Link>
    );
  }
}

export default ResendConfirmationEmail;
